import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { WebhooksApiAdapter } from '../adapters/WebhooksApiAdapter';

export const WEBHOOK_ENDPOINTS_QUERY_KEY = 'webhook-endpoints';

export const useWebhookEndpoints = () => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new WebhooksApiAdapter(httpClient);

  return useQuery({
    queryKey: [WEBHOOK_ENDPOINTS_QUERY_KEY],
    queryFn: () => adapter.getEndpoints(),
    staleTime: 2 * 60 * 1000,
  });
};

export const useWebhookEventTypes = () => {
  const httpClient = createHttpClient(apiClientWH);
  const adapter = new WebhooksApiAdapter(httpClient);

  return useQuery({
    queryKey: ['webhook-event-types'],
    queryFn: () => adapter.getEventTypes(),
    staleTime: 10 * 60 * 1000,
  });
};
